function fn_visual() {
    var visual = $("#hp-visual");
    var visual_inner = $('.hp-visual-inner');
    if (visual_inner.length) {
        if ($(window).width() > 480) {
            visual_inner.slick({
                lazyLoad: 'progressive',
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 9000,
                fade: true,
                cssEase: 'linear',
                arrows: false,
                dots: true,
                pauseOnHover: false
            });
            visual_inner.on('beforeChange', function(){
                $(this).find(".slick-active").next().find("img").addClass("lazyload");
            });
        }

    }
    visual.find(".content-explore a").on('click', function (e) {
        e.preventDefault();
        $('html,body').animate({
            scrollTop: visual.next("*").offset().top - 0
        }, 700);
    });
}
function fn_main_rooms_slider() {
/*    var rooms = $("#rooms-tabs");
    var rooms_slider = $('.rooms-tabs-inner');
    if (rooms_slider.length) {
            rooms_slider.slick({
                infinite: true,
                speed: 900,
                slidesToShow: 4,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 9000,
                cssEase: 'ease',
                arrows: true,
                dots: true,
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3 ,
                            slidesToScroll: 3,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 2 ,
                            slidesToScroll: 2,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 520,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: "unslick"
                    }
                ]
            });
    }*/

    slick_slider();
    $(window).resize(slick_slider);
    function slick_slider() {
        var wrapper = $(".rooms-tabs-inner");
        if ($(".slick-initialized").length) {
            wrapper.slick('unslick');
        }
        wrapper.slick({
            infinite: true,
            speed: 900,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 9000,
            cssEase: 'ease',
            arrows: true,
            dots: true,
            pauseOnHover: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4 ,
                        slidesToScroll: 4,
                        infinite: true
                    }
                },
                {
                    breakpoint: 960,
                    settings: "unslick"
                },
                {
                    breakpoint: 800,
                    settings: "unslick"
                }
            ]
        });
    }



}
function fn_special_offfer(){
    var visual_inner = $('.special-offers-inner');
    if (visual_inner.length) {
            visual_inner.slick({
                lazyLoad: 'progressive',
                infinite: true,
                speed: 600,
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 3000,
                fade: false,
                cssEase: 'ease',
                arrows: true,
                dots: false,
                pauseOnHover: false,
                nextArrow: '<button type="button" class="slick-next slick-arrow"><span class="path1"></span><span class="path2"></span></button>',
                prevArrow: '<button type="button" class="slick-prev slick-arrow"><span class="path1"></span><span class="path2"></span></button>',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3 ,
                            slidesToScroll: 3,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 2 ,
                            slidesToScroll: 2,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 520,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
    }
}
function fn_special_offfers_side_slider(){
    var visual_inner = $('.offer-inner-slider');
    if (visual_inner.length) {
        visual_inner.slick({
            lazyLoad: 'progressive',
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            fade: false,
            cssEase: 'ease',
            arrows: false,
            dots: true,
            pauseOnHover: false
        });
    }
}
function fn_rooms_info_slick_slider(){
    var rooms_inner = $('.sc-slider');
    if (rooms_inner.length) {
            rooms_inner.slick({
                infinite: true,
                speed: 600,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 3000,
                cssEase: 'ease',
                arrows: true,
                fade: true,
                dots: false,
                pauseOnHover: false,
                nextArrow: '<button type="button" class="slick-next slick-arrow"><span class="path1"></span><span class="path2"></span></button>',
                prevArrow: '<button type="button" class="slick-prev slick-arrow"><span class="path1"></span><span class="path2"></span></button>',
            });
    }
}